// Copyright 2021-2022 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import PackageView from "./PackageView";

export default PackageView;
